import React, { useEffect, useState } from "react";
import supabase from "../../../supabaseClient";

const fileExtensions = {
  pdf: "📄",
  doc: "📄",
  docx: "📄",
  txt: "📄",
  xls: "📊",
  xlsx: "📊",
  ppt: "📊",
  pptx: "📊",
  zip: "🗜️",
  rar: "🗜️",
  default: "📁"
};

function getFileIcon(filename) {
  const ext = filename.split(".").pop().toLowerCase();
  return fileExtensions[ext] || fileExtensions.default;
}

const FilesTab = ({ event }) => {
  const [filePosts, setFilePosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFiles = async () => {
      setLoading(true);
      if (!event?.id) {
        setFilePosts([]);
        setLoading(false);
        return;
      }
      const { data: posts, error } = await supabase
        .from("posts")
        .select("id, user_id, media_url, media_type, created_at")
        .eq("event_id", event.id)
        .not("media_url", "is", null);
      if (error) {
        console.error('Error fetching files for event:', error);
        setFilePosts([]);
        setLoading(false);
        return;
      }
      // Filter for files (not images, videos, audio)
      const filePostsFiltered = posts.filter(
        post => post.media_url && post.media_type && !post.media_type.startsWith("image") && !post.media_type.startsWith("video") && !post.media_type.startsWith("audio")
      );
      // Generate public URLs for files
      const postsWithPublicUrls = await Promise.all(
        filePostsFiltered.map(async post => {
          let publicUrl = post.media_url;
          if (post.media_url && !/^https?:\/\//.test(post.media_url)) {
            const { data } = supabase.storage.from("post-media").getPublicUrl(post.media_url);
            if (data?.publicUrl) {
              publicUrl = data.publicUrl;
            }
          }
          return { ...post, media_url: publicUrl };
        })
      );
      setFilePosts(postsWithPublicUrls);
      setLoading(false);
    };
    fetchFiles();
  }, [event]);

  return (
    <div className="event-files-tab">
      <h2>Event Files</h2>
      <div className="files-list">
        {loading ? (
          <div>Loading files...</div>
        ) : filePosts.length > 0 ? (
          filePosts.map(post => (
            <div className="file-card" key={post.id}>
              <span className="file-icon">{getFileIcon(post.media_url)}</span>
              <a href={post.media_url} target="_blank" rel="noopener noreferrer" className="file-link">
                {post.media_url.split("/").pop()}
              </a>
              <span className="file-meta">{post.user_id} • {new Date(post.created_at).toLocaleString()}</span>
            </div>
          ))
        ) : (
          <div>No files found for this event.</div>
        )}
      </div>
    </div>
  );
};

export default FilesTab;